import React, {useEffect, useState} from 'react'
import Modal from 'react-modal';
import {SubmitHandler, useForm} from "react-hook-form";
import {modalServiceSubject} from "../../services/modal.service";
import {loginMember} from "../../store/auth.store";
import {ApiService} from "../../lib/http.service";
import {env} from "../../constants/global.vars";



function ValidationSmsModal(props: any) {

    const [errorMessage, setErrorMessage] = useState<any>("");
    const [isActiveLoading, setIsActiveLoading] = useState(false);

    function closeModal() {
        props.setIsOpen(false);
    }

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm<any>()

    const onSubmit: SubmitHandler<any> = data => {
        codeMobileApi(data)
    }

    const codeMobileApi = (data: any) => {
        setIsActiveLoading(true);
        var registerData = loginMember;
        registerData.code = data.code;

        let api = new ApiService();
        api
            .start("post", env.api + "/member/api/mobile_validation/", registerData, false).then(
            (result: any) => {
                setIsActiveLoading(false);
                if (result.status) {
                    props.setValidationToken(result.data.validation_token);
                    props.setIsOpen(false);
                    props.onCloseFunction(result.data.validation_token);
                } else {
                    if (result.data && result.data.hasOwnProperty('re-register')) {
                        modalServiceSubject.next({
                            title: "Uyarı!",
                            content: 'Lütfen tekrar deneyiniz.',
                            confirm: {
                                cancel: {label: 'Tamam'}
                            },
                            timeout: 0
                        })
                        props.setIsOpen(false);
                    } else {
                        setErrorMessage(result.message);
                    }
                }
            }
        )
    }

    if (!props.modalIsOpen) {
        return <></>
    }

    return (
        <>

            <Modal
                isOpen={props.modalIsOpen}
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                shouldReturnFocusAfterClose={false}
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        width: '920px',
                        maxHeight: 'calc(100% - 40px)',
                        marginRight: '-50%',
                        maxWidth: '500px',
                        padding: '0px',
                        transform: 'translate(-50%, -50%)',
                        background: 'var(--bs-white)',
                        borderRadius: 'var(--bs-border-radius-xl)',
                        border: 0,
                        zIndex:13
                    },
                    overlay: {
                        zIndex: 14,
                        backgroundColor: 'rgba(0, 0, 0, 0.25)',
                        backdropFilter: 'blur(10px)',
                    }
                }}
                contentLabel=""
            >

                <div className={`modal-header`}>
                    <h3 className="text-lg mb-0 text-white text-bolder text-center w-100">Telefon Doğrulama</h3>


                </div>
                <div className="card p-3">

                    {!isActiveLoading &&
                        <>
                            <div className="pt-4 mb-4 pb-1">
                                <p className="text-md text-center">
                                    <span className="text-md text-primary text-bold">{loginMember.mobile} </span>numaralı
                                    telefona gelen 6 haneli doğrulama kodunu giriniz. <br/>
                                    {props.modalIsOpen ? <>
                                        <CountDown timer={180}
                                                   mobileConfirmToken={props.mobileConfirmToken}></CountDown>
                                    </> : <></>}</p>
                            </div>

                    </>
                    }
                    {isActiveLoading && <p>
                        Telefon numaranız ve üyelik bilgileriniz doğrulanıyor lütfen bekleyiniz...
                    </p>}
                    <div className="card-body p-0">
                        {!isActiveLoading && <form onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                <input placeholder={"Doğrulama Kodu"} {...register('code', {
                                    required: true,
                                    maxLength: 6,
                                    minLength: 6
                                })} type={"number"}
                                       className="form-control"/>
                                {errors.code && errors.code.type === "required" &&
                                    <span className="text-validation">Lütfen doğrulama kodu giriniz.</span>}
                            </div>
                            {errorMessage && errorMessage !== '' &&
                                <p className="py-1 mt-1 alert alert-danger text-center">{errorMessage}</p>}

                            <input className="button sm secondary filled mt-3 w-100 text-bolder mx-1 p-0" type="submit" value="DOĞRULA"/>

                        </form>}
                        {/*{isActiveLoading && <div className="d-flex justify-content-center mb-2 mt2">*/}
                        {/*    <img className="loadingRotationImage" src={Clock} width="50"/>*/}
                        {/*</div>}*/}
                    </div>
                </div>
            </Modal>

        </>
    )
}

export default ValidationSmsModal

function secondsToTime(secs: number) {
    let hours = Math.floor(secs / (60 * 60));
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    let obj = {
        "h": String(hours).padStart(2, '0'),
        "m": String(minutes).padStart(2, '0'),
        "s": String(seconds).padStart(2, '0')
    };
    return obj;
}

let timerRegisterCountDown: any;

export function CountDown(props: any) {
    const timer = props.timer;
    const [timeLeft, setTimeLeft] = useState(timer)

    useEffect(() => {
        if (timeLeft > 0) {
            timerRegisterCountDown = setTimeout(() => {
                setTimeLeft(timeLeft - 1)
            }, 1000);
        }

        return () => {
            clearTimeout(timerRegisterCountDown);
        }
    }, [timeLeft])

    if (timeLeft <= 0) {
        return (<>Süre doldu! tekrar doğrulama kodu göndermeniz gerekiyor. <a onClick={() => {
            var data: any = loginMember;
            let api = new ApiService();
            api
                .start("post", env.api + "/member/api/mobile_validation/", data, false).then((res: any) => {
                setTimeLeft(res.data.timeout);
            })

        }} style={{cursor: 'pointer', fontWeight: 'bold', color: 'var(--color-danger)'}}>Tekrar Gönder</a> </>)
    }

    return (<><span><b>{secondsToTime(timeLeft).m}:{secondsToTime(timeLeft).s}</b> saniye sonra yeniden kod gönderebilirsiniz.</span></>)
}
